import { __decorate, __metadata } from "tslib";
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { IsInt, IsOptional, Min } from 'class-validator';
import { DEFAULT_PREP_TIME } from '../../order-config/constants';
import { OrderConfigExposeGroup } from '../../order-config/interface';
export class ReadPrepTimeCalculationContextDto {
}
__decorate([
    ApiProperty({ type: () => Number, description: 'Average preparation time (in minutes)', default: DEFAULT_PREP_TIME }),
    IsInt({ always: true }),
    Min(0, { always: true }),
    IsOptional({ groups: [OrderConfigExposeGroup.PATCH, OrderConfigExposeGroup.CREATE] }),
    Expose({ groups: [OrderConfigExposeGroup.CREATE, OrderConfigExposeGroup.READ, OrderConfigExposeGroup.PATCH] }),
    __metadata("design:type", Number)
], ReadPrepTimeCalculationContextDto.prototype, "prepTime", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Number, description: 'Average delay time (in minuted)' }),
    IsInt({ always: true }),
    Min(0, { always: true }),
    IsOptional({ always: true }),
    Expose({ groups: [OrderConfigExposeGroup.CREATE, OrderConfigExposeGroup.READ, OrderConfigExposeGroup.PATCH] }),
    __metadata("design:type", Number)
], ReadPrepTimeCalculationContextDto.prototype, "delayTime", void 0);
//# sourceMappingURL=ReadPrepTimeCalculationContextDto.js.map